import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=4cb37b06"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports